import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#080a0f] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/0758b00e-4705-432c-90d8-8173dccd9e57.png"
              alt="ChatNow"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-white/40 text-sm leading-relaxed">
              Dünya genelinde insanlarla anında görüntülü ve metin sohbeti. Güvenli, hızlı ve premium deneyim.
            </p>
            <div className="flex items-center gap-3 mt-6">
              {['ri-twitter-x-fill', 'ri-instagram-line', 'ri-tiktok-fill', 'ri-discord-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/5 hover:bg-cyan-500/20 hover:text-cyan-400 text-white/50 transition-all duration-200 cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-5">Ürün</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Nasıl Çalışır?', href: '/#how-it-works' },
                { label: 'Özellikler', href: '/#features' },
                { label: 'Premium', href: '/premium' },
                { label: 'Güvenlik', href: '/safety' },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-5">Şirket</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Hakkımızda', href: '#' },
                { label: 'Kariyer', href: '#' },
                { label: 'Blog', href: '#' },
                { label: 'Basın', href: '#' },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white/30 text-xs font-semibold uppercase tracking-widest mb-5">Yasal</h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Gizlilik Politikası', href: '#' },
                { label: 'Kullanım Şartları', href: '#' },
                { label: 'Çerez Politikası', href: '#' },
                { label: 'Yardım / SSS', href: '/help' },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-white/50 hover:text-white text-sm transition-colors cursor-pointer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/25 text-xs">© 2026 ChatNow. Tüm hakları saklıdır.</p>
          <div className="flex items-center gap-6">
            <span className="flex items-center gap-2 text-white/25 text-xs">
              <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse inline-block" />
              Tüm sistemler çalışıyor
            </span>
            <span className="text-white/20 text-xs">18+ Platform</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
